  <main>
    <div style="width:100%; height:100vh;">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6135.99679344212!2d30.677810760698694!3d36.89269678297358!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14c39176c6c84b8f%3A0x5b9862dc7a9074dd!2sHi%20Travel%20Ltd.%20Sti.!5e0!3m2!1str!2str!4v1761807664466!5m2!1str!2str" width="100%" height="100%" style="border:0; display:block; width:100%; height:100%;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
    <section>
      <div class="relative container">
        <div class="row justify-end">
          <div class="col-xl-5 col-lg-7">
            <div class="map-form px-40 pt-40 pb-50 lg:px-30 lg:py-30 md:px-24 md:py-24 bg-white rounded-4 shadow-4">
              <div class="text-22 fw-500">
                İletişim Formu
              </div>

              <div class="row y-gap-20 pt-20">
                <div class="col-12">

                  <div class="form-input ">
                    <input type="text" required>
                    <label class="lh-1 text-16 text-light-1">Adınız Soyadınız</label>
                  </div>

                </div>
                <div class="col-12">

                  <div class="form-input ">
                    <input type="text" required>
                    <label class="lh-1 text-16 text-light-1">Email Adresiniz</label>
                  </div>

                </div>
                <div class="col-12">

                  <div class="form-input ">
                    <input type="text" required>
                    <label class="lh-1 text-16 text-light-1">Konu</label>
                  </div>

                </div>
                <div class="col-12">

                  <div class="form-input ">
                    <textarea required rows="4"></textarea>
                    <label class="lh-1 text-16 text-light-1">Mesajınız</label>
                  </div>

                </div>
                <div class="col-auto">

                  <a href="#" class="button px-24 h-50 -dark-1 bg-blue-1 text-white">
                    Mesaj Gönder <div class="icon-arrow-top-right ml-15"></div>
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="layout-pt-md layout-pb-lg">
      <div class="container">
        <div class="row x-gap-80 y-gap-20 justify-between">
        

          <div class="col-lg-3">
            <div class="text-14 text-light-1">Adres</div>
            <div class="text-18 fw-500 mt-10">Varlık, Piri Reis Cd. No:38, 07230 Muratpaşa/Antalya</div>
          </div>

          <div class="col-auto">
            <div class="text-14 text-light-1">Müşteri Destek Hattı</div>
            <div class="text-18 fw-500 mt-10">0242 212 02 24</div>
          </div>

          <div class="col-auto">
            <div class="text-14 text-light-1">Canlı Destek</div>
            <div class="text-18 fw-500 mt-10">destek&#64;pusulatatil.com</div>
          </div>

          <div class="col-auto">
            <div class="text-14 text-light-1">Sosyal Medya Hesaplarımız</div>
            <div class="d-flex x-gap-20 items-center mt-10">
              <a href="#"><i class="icon-facebook text-14"></i></a>
              <a href="#"><i class="icon-twitter text-14"></i></a>
              <a href="#"><i class="icon-instagram text-14"></i></a>
              <a href="#"><i class="icon-linkedin text-14"></i></a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <app-features></app-features>
    <app-newsletter></app-newsletter>
  </main>